import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  IterableDiffers,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { formatDate } from '@angular/common';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { ColumnToNotDisplay } from 'src/app/enums/ColumnsToNotDisplay';
import { TableTagListMapper } from 'src/app/mapper/table/table-tag-list.mapper';
import { TagInfos } from 'src/swagger-gen/web-secured/models';
import { TableColumn } from '../../tinea-table/models/tableColumn';


@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TagComponent implements OnInit, OnDestroy, OnChanges {
  @Input() tag: TagInfos;

  @Input() tableColumns: TableColumn[] = [];

  @Output() eventOnClick = new EventEmitter<any>();

  @Input() columnsToNotDisplay: ColumnToNotDisplay;

  differ: any;

  display: boolean;

  /**
   * Current application language
   */
  language: 'fr' | 'en' = 'fr';

  /**
   * Date format to display depending of language
   */
  dateFormat: string;
  private subscriptions: Subscription[] = [];

  constructor(
    private logger: NGXLogger,
    private ref: ChangeDetectorRef,
    differs: IterableDiffers,
    private tableTagListMapper: TableTagListMapper
  ) {
    this.differ = differs.find([]).create(null);
  }
  ngOnChanges(changes: SimpleChanges): void {
    /* Map tags to hide some values from display (ex. false -> '' */
    // const tagMappedValue = this.tableTagListMapper.getValue(
    //   changes.tag.currentValue
    // );
    // this.tag.value = tagMappedValue;
  }

  ngOnInit() {
    this.setDateFormat();
    this.setNumberFormat();
    this.display = this.columnsToNotDisplay === ColumnToNotDisplay.NotDisplay;
  }

  /**
   * Set the date format depending on the language
   */
  setDateFormat() {
    if(this.tag.lastValues) {
      if (this.tag.lastValues.hasOwnProperty('lastValueDatetime')) {
        if (this.language === 'fr') {
          this.dateFormat = 'dd/MM/yyyy HH:mm:ss';
          this.tag.lastValues.lastValueDatetime = formatDate(this.tag.lastValues.lastValueDatetime, this.dateFormat, 'fr-FR');
  
        } else {
          this.dateFormat = 'MM/dd/yyyy HH:mm:ss';
          this.tag.lastValues.lastValueDatetime = formatDate(this.tag.lastValues.lastValueDatetime, this.dateFormat, 'en-EN');
        }
      }
    }
  }

  setNumberFormat() {
    if(this.tag.lastValues) {
      if (this.tag.lastValues.hasOwnProperty('lastValue') && !isNaN(parseFloat(this.tag.lastValues.lastValue))) {
        this.tag.lastValues.lastValue = parseFloat(this.tag.lastValues.lastValue).toFixed(1);
      }
    }
  }

  ngOnDestroy() {
    if (this.subscriptions !== undefined) {
      this.subscriptions.forEach((s) => s.unsubscribe());
    }
  }

  columnIsDiplayed(propertyName: string): boolean {
    let isDisplayed = false;
    const element = this.tableColumns.find(
      (e) => e.propertyName === propertyName
    );
    if (element) {
      isDisplayed = element.displayed ? true : false;
    }
    return isDisplayed;
  }

  onEventOnClick(tag: TagInfos) {
    this.eventOnClick.emit(tag);
  }
}
